export const NAMESPACE = "SessionsSectionStore";

export const SORT_IDS = {
  NAME_AZ: "name_az",
  NAME_ZA: "name_za",
  LAST_UPDATED: "last_updated",
  NEWEST_TO_OLDEST: "oldest_to_newest"
};
export const SORT_VALUES = {
  [SORT_IDS.NAME_AZ]: "A - Z (Name)",
  [SORT_IDS.NAME_ZA]: "Z - A (Name)",
  [SORT_IDS.LAST_UPDATED]: "Last Updated",
  [SORT_IDS.OLDEST_TO_NEWEST]: "Oldest to Newest"
};

export const SORT_OPTIONS = [
  {
    id: SORT_IDS.NAME_AZ,
    value: SORT_VALUES[SORT_IDS.NAME_AZ]
  },
  {
    id: SORT_IDS.NAME_ZA,
    value: SORT_VALUES[SORT_IDS.NAME_ZA]
  },
  {
    id: SORT_IDS.LAST_UPDATED,
    value: SORT_VALUES[SORT_IDS.LAST_UPDATED]
  },
  {
    id: SORT_IDS.OLDEST_TO_NEWEST,
    value: SORT_VALUES[SORT_IDS.OLDEST_TO_NEWEST]
  }
];
export const FILTER_IDS = {
  RECENTLY_UPDATED: "recently_updated",
  FILE_CONTENT_ATTACHED: "file_content_attached"
};
export const FILTER_VALUES = {
  [FILTER_IDS.RECENTLY_UPDATED]: "Recently Updated",
  [FILTER_IDS.FILE_CONTENT_ATTACHED]: "Files Attached"
};

export const FILTER_OPTIONS = [
  {
    id: FILTER_IDS.RECENTLY_UPDATED,
    value: FILTER_VALUES[FILTER_IDS.RECENTLY_UPDATED]
  },
  {
    id: FILTER_IDS.FILE_CONTENT_ATTACHED,
    value: FILTER_VALUES[FILTER_IDS.FILE_CONTENT_ATTACHED]
  }
];

export const SEARCH_BAR_INSTANCE_ID_SESSION_SECTION =
  "SearchBarInstanceIdSessionSection";
